import React, { useState, useEffect } from 'react'
import AdminDashboardLayout from './superadmin/AdminDashboardLayout'
import { corporateEmployeeStatusAPI, corporateShowEmployeesAPI } from '../redux/slices/CorporateAddEmployee';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { errorHandler } from '../constants/base';

const ViewEmployee = () => {

    const dispatch = useDispatch();
    const employeeLoading = useSelector((state) => state?.coporateAddEmployeSlice?.employeeLoading);
    const allEmployees = useSelector((state) => state?.coporateAddEmployeSlice?.allEmployees);
    const pagination = useSelector((state) => state?.coporateAddEmployeSlice?.pagination);
    const [currentPage, setCurrentPage] = useState(pagination.current_page);
    const param = useParams()
    
    const corporate = {
        id: param?.id,
        page: currentPage
    }

    // Fetch employee based on the current page
    const fetchEmployees = async () => {
        try {
            await dispatch(corporateShowEmployeesAPI(corporate));
        } catch (error) {
            console.error("Error fetching employees:", error);
        }
    };

    useEffect(() => {
        fetchEmployees(currentPage);
    }, [param?.id, currentPage])

    // Fetch employee based on the current page

    // Handle page navigation
    const handlePageChange = (page) => {
        setCurrentPage(page);
    }
    // FETCH EMPLOYEE

    // UPDATE EMPLOOYEE STATUS
    const handleChangeStatus = async (employee_id, status, coporate_id) => {
        const res = await dispatch(corporateEmployeeStatusAPI({ coporate_id, employee_id, status }))

        if (res.type === 'corporateEmployeeStatusAPI/fulfilled') {
            if (res.payload.success || res.payload.status || res.payload.data.status === 200) {
                fetchEmployees();
                toast.success("Corporate Status Update Successfully");
            } else {
                errorHandler(res.payload.errors);
            }
        } else if (res.type === 'corporateEmployeeStatusAPI/rejected') {
            errorHandler(res.payload.errors);
        } else {
            toast.error('Sorry, something went wrong!');
        }
    }
    // UPDATE EMPLOOYEE STATUS


    return (
        <>
            <AdminDashboardLayout>
                {employeeLoading ? <div className="loading-center-on-page">
                    <i
                        style={{ fontSize: "52px" }}
                        className="fa-solid fa-spinner fa-spin"
                    ></i>
                </div> : <div> <table className="table superadmin-table-box">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Full Name</th>
                            <th scope="col">Email</th>
                            <th scope="col">Phone No</th>
                            <th scope="col">Status</th>
                            <th scope="col">Actions</th>
                        </tr>
                    </thead>

                    <tbody>
                        {allEmployees?.map((employee, index) => {
                            return <tr key={index}>
                                <th scope="row">{index + 1}</th>
                                <td>{employee?.name}</td>
                                <td>{employee?.email}</td>
                                <td>{employee?.phone_no}</td>
                                <td>
                                    <select
                                        name="status"
                                        id="status"
                                        value={employee.status}
                                        onChange={(e) => handleChangeStatus(employee?.id, e?.target?.value, employee?.parent_id)}
                                        className="dashboard-select"
                                    >
                                        <option value="Pending">Pending</option>
                                        <option value="Active">Active</option>
                                        <option value="Block">Block</option>
                                    </select>
                                </td>
                                <td>
                                    <div className='actions-box'>
                                        <Link to={`/admin/employees/view/${employee?.id}/${employee?.parent_id}`}>
                                            <i className="fas fa-eye"></i>
                                        </Link>
                                    </div>
                                </td>
                            </tr>
                        })}
                    </tbody>
                </table>
                    {/* Pagination Controls */}
                    <div className="pagination">
                        {pagination.current_page > 1 && (
                            <button onClick={() => handlePageChange(pagination.current_page - 1)}>&laquo; Previous</button>
                        )}

                        {[...Array(pagination.total_pages)].map((_, i) => (
                            pagination.total_pages >= 2 ?
                                <button
                                    key={i + 1}
                                    className={i + 1 === pagination.current_page ? 'active' : ''}
                                    onClick={() => handlePageChange(i + 1)}
                                >
                                    {i + 1}
                                </button> : ""
                        ))}

                        {pagination.current_page < pagination.total_pages && (
                            <button onClick={() => handlePageChange(pagination.current_page + 1)}>Next &raquo;</button>
                        )}
                    </div>
                </div>
                }
            </AdminDashboardLayout>
        </>
    )
}

export default ViewEmployee